import * as React from "react";

export const IconTrash = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="10" cy="10" r="8" fill="white" />
    <path
      d="M7.83301 13.75L9.99967 11.5833L12.1663 13.75L13.333 12.5833L11.1663 10.4167L13.333 8.25L12.1663 7.08333L9.99967 9.25L7.83301 7.08333L6.66634 8.25L8.83301 10.4167L6.66634 12.5833L7.83301 13.75ZM5.83301 17.5C5.37467 17.5 4.98231 17.3368 4.65592 17.0104C4.32954 16.684 4.16634 16.2917 4.16634 15.8333V5H3.33301V3.33333H7.49967V2.5H12.4997V3.33333H16.6663V5H15.833V15.8333C15.833 16.2917 15.6698 16.684 15.3434 17.0104C15.017 17.3368 14.6247 17.5 14.1663 17.5H5.83301Z"
      fill="currentColor"
    />
  </svg>
);
